// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"17803a7a","390":"1bd65376","652":"1b5e7ae1"}[chunkId] + ".chunk.css";
};